import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Grid, TextField, MenuItem, Button, Switch, FormControlLabel } from '@mui/material';
import { saveEntiteSettings, loadEntiteSettings, EntiteSettings } from '../../utils/numbering';

const EntiteSettingsPage: React.FC = () => {
  const [settings, setSettings] = useState<EntiteSettings>(loadEntiteSettings());
  const [saved, setSaved] = useState(false);

  useEffect(() => { setSettings(loadEntiteSettings()); }, []);

  const handleSave = () => {
    saveEntiteSettings(settings);
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Paramètres de l'entité
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Numérotation des écritures, fiche d'imputation et informations d'en-tête
        </Typography>
      </Box>

      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nom de l'entité"
                value={settings.entityName}
                onChange={e => setSettings({ ...settings, entityName: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={<Switch checked={settings.autoGenerateFiche} onChange={e => setSettings({ ...settings, autoGenerateFiche: e.target.checked })} />}
                label="Générer automatiquement la fiche d'imputation à l'enregistrement"
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                select
                label="Portée de numérotation"
                value={settings.numbering.scope}
                onChange={e => setSettings({ ...settings, numbering: { ...settings.numbering, scope: e.target.value as any } })}
              >
                <MenuItem value="annual">Annuel</MenuItem>
                <MenuItem value="monthly">Mensuel</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                select
                label="Type"
                value={settings.numbering.type}
                onChange={e => setSettings({ ...settings, numbering: { ...settings.numbering, type: e.target.value as any } })}
              >
                <MenuItem value="numeric">Numérique</MenuItem>
                <MenuItem value="alphanumeric">Alphanumérique</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Préfixe"
                value={settings.numbering.prefix || ''}
                onChange={e => setSettings({ ...settings, numbering: { ...settings.numbering, prefix: e.target.value } })}
                placeholder="Ex: ENT-"
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                type="number"
                label="Zero padding"
                value={settings.numbering.pad ?? 5}
                onChange={e => setSettings({ ...settings, numbering: { ...settings.numbering, pad: Number(e.target.value) || 5 } })}
              />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" onClick={handleSave}>{saved ? 'Enregistré' : 'Enregistrer'}</Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default EntiteSettingsPage;